import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { faBolt, faCalendarAlt } from '@fortawesome/pro-solid-svg-icons'

import { Alert } from 'Components/_theme'

import {
  E2E_CANCEL_DEVICE_OPTION_IMMEDIATE,
  E2E_CANCEL_DEVICE_OPTION_SCHEDULED,
} from 'Constants/e2e'

import {
  CANCEL_DEVICE_FORM_FIELDS,
  CANCEL_DEVICE_LEAD_TIME_INFO_ID,
} from '../../CancelDeviceModal.constants'
import { CancellationTypeEnum } from '../../CancelDeviceModal.types'
import { CancellationOption } from '../CancellationOption/CancellationOption'
import type { CancellationTypeSelectorProps } from './CancellationTypeSelector.types'

export const CancellationTypeSelector = (
  props: CancellationTypeSelectorProps,
) => {
  const { selectedType, onSelect, leadTime } = props
  const intl = useIntl()

  const handleSelectImmediate = useCallback(() => {
    onSelect(CancellationTypeEnum.IMMEDIATE)
  }, [onSelect])

  const handleSelectScheduled = useCallback(() => {
    onSelect(CancellationTypeEnum.SCHEDULED)
  }, [onSelect])

  return (
    <fieldset className="d-flex flex-column gap-2 mb-3 border-0 p-0">
      <legend className="visually-hidden">
        {intl.formatMessage({ id: 'CancelDevice_cancellationType_legend' })}
      </legend>

      <CancellationOption
        description={
          <FormattedMessage id="CancelDevice_cancelNow_description" />
        }
        e2eSelector={E2E_CANCEL_DEVICE_OPTION_IMMEDIATE}
        icon={faBolt}
        isSelected={selectedType === CancellationTypeEnum.IMMEDIATE}
        name={CANCEL_DEVICE_FORM_FIELDS.CANCELLATION_TYPE}
        onChange={handleSelectImmediate}
        title={<FormattedMessage id="CancelDevice_cancelNow_title" />}
        value={CancellationTypeEnum.IMMEDIATE}
      />

      <CancellationOption
        description={
          <FormattedMessage id="CancelDevice_scheduleCancellation_description" />
        }
        e2eSelector={E2E_CANCEL_DEVICE_OPTION_SCHEDULED}
        icon={faCalendarAlt}
        isSelected={selectedType === CancellationTypeEnum.SCHEDULED}
        name={CANCEL_DEVICE_FORM_FIELDS.CANCELLATION_TYPE}
        onChange={handleSelectScheduled}
        title={
          <FormattedMessage id="CancelDevice_scheduleCancellation_title" />
        }
        value={CancellationTypeEnum.SCHEDULED}
      />

      {!!leadTime && selectedType === CancellationTypeEnum.SCHEDULED && (
        <div id={CANCEL_DEVICE_LEAD_TIME_INFO_ID}>
          <Alert className="mt-1" variant="info">
            <FormattedMessage
              id="CancelDevice_organizationLeadTime"
              values={{ days: leadTime }}
            />
          </Alert>
        </div>
      )}
    </fieldset>
  )
}
